import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { cardIdRegex } from 'src/shared/regex';

export const cardIdRule = (): Rule => {
  const { t } = useTranslation();

  return ({
    required: true,
    message: t('Please enter correct card ID'),
    pattern: cardIdRegex,
  });
};
